import { get } from '../utils/api-utils';

// Today's QQQ three-layer strategy signal (B+ by default, or B), with key
// levels, next triggers, recent signals, chart series and backtest stats.
export const fetchBPlusSignal = async (version = 'bplus') => {
    try {
        return await get('/quant/bplus', { version }, 'fastAPI');
    } catch (error) {
        console.error('Error fetching B+ signal:', error);
        throw error;
    }
};

// Nasdaq-100 (QQQ) forward P/E: latest reading, history since 2001,
// percentiles against the last 5/10/20 years and a WSJ cross-check.
export const fetchForwardPE = async () => {
    try {
        return await get('/quant/forward-pe', {}, 'fastAPI');
    } catch (error) {
        console.error('Error fetching forward P/E:', error);
        throw error;
    }
};
